import { Component } from '@angular/core';
import { BaseComponent } from '@components/base/base.component';
import { ContentTiles } from '@interfaces/content-tiles.interface';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.less']
})
export class AboutUsComponent extends BaseComponent {
  public tiles: ContentTiles[] = [
    {
      title: 'byt_home_about_us_title_1',
      description: 'byt_home_about_us_description_1',
      image:
        'https://admin.bookyourtrail.com/assets/66a3ba6b-81e0-4ab1-b5d4-9a3b885a2558.jpg',
      url: `${this.siteSettings.links[this.currLang]?.consulting}`
    },
    {
      title: 'byt_home_about_us_title_2',
      description: 'byt_home_about_us_description_2',
      image:
        'https://admin.bookyourtrail.com/assets/ec19f773-bb9a-4375-8db8-f976ea4f0588.jpg',
      url: `${this.siteSettings.links[this.currLang]?.trekking}`
    }
  ];
}
